<template>
  <div class="home">
    <div class="portrait flex-row m-b-20" @click="viewPage()">
      <div class="flex-row portraitGroup">
        <img :src="lion" alt="" class="portraitImg">
        <p>{{dataList.customerName}}</p>
      </div>
      <img :src="back" alt="" class="back">
    </div>
    <tips></tips>
    <serves></serves>
    <!-- <contents></contents> -->
  </div>
</template>
<script>
import back from '@/assets/img/ping.jpg'
import lion from '@/assets/img/lion.jpg'
import tips from '@/components/tips'
import serves from '@/components/serves'
import contents from '@/components/content'
import { getCustomerInfo } from '@/api/index';
export default {
  components: {
    tips,
    serves,
    contents
  },
  name: 'home',
  data(){
    return{
      back,
      lion,
      dataList:{
          customerName:'',
          address: ''
      },
    }
  },
  created(){
    this.getData();
  },
  methods:{
    viewPage(){
      this.$router.push({path:'/info'})
    },
    getData(){
        let data = this.$loca.getItem('phone');
        getCustomerInfo({phone: data}).then(res=>{
            this.dataList = res.data;
        }).catch(error=>{

        })
    }
  }
}
</script>
<style lang="scss" scoped>
  .home{
    background:rgba(237,237,237,1);
  }
  .headr{
    height: 96px;
    font-size:32px;
    color: $color-51;
    line-height:96px;
    text-align: center;
  }
  .portrait{
    height: 128px;
    line-height: 128px;
    background: $ffff;
    align-items: center;
    padding: 0 30px;
    justify-content: space-between;
  }
  .portraitImg{
    height: 93px;
    width: 93px;
    border-radius: 50%;
    margin-right: 27px;
  }
  .portraitGroup{
    align-items: center;
  }
  .portraitGroup p {
    line-height: 128px;
    font-size:30px;
    color:$color-51;
  }
  .back{
    width: 20px;
    height: 36px;
  }
</style>
